import { Box, HStack } from '@chakra-ui/react';

type PillProps = {
  label: string;
  bg: string;
  color: string;
  // The leading dot defaults to the text color; a badge can override it and add a soft glow ring.
  dotColor?: string;
  dotGlow?: string;
};

export const Pill = ({ label, bg, color, dotColor, dotGlow }: PillProps) => (
  <HStack
    as="span"
    spacing="5px"
    bg={bg}
    color={color}
    borderRadius="full"
    px="9px"
    py="4px"
    fontSize="10.5px"
    fontWeight="700"
    letterSpacing="0.04em"
    textTransform="none"
  >
    <Box
      as="span"
      w="5px"
      h="5px"
      borderRadius="full"
      bg={dotColor ?? color}
      boxShadow={dotGlow != null ? `0 0 0 3px var(--chakra-colors-${dotGlow})` : undefined}
    />
    <span>{label}</span>
  </HStack>
);

export default Pill;
